const navbarLinkItem = [
  {
    link: "Beranda",
    to: "/",
  },
  {
    link: "Bank Sampah",
    to: "/bank-sampah",
  },
  {
    link: "Daur Ulang",
    to: "/daur-ulang",
  },
  {
    link: "Layanan",
    to: "/layanan",
  },
  {
    link: "Tentang Kami",
    to: "/tentang-kami",
  },
  {
    link: "Cuaca",
    to: "/cuaca",
  },
];

export default navbarLinkItem;
